import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export enum RoutesIds {
  pulses = 'pulses',
  pulse = 'pulse',
}

export const pulsesRouteRef = createRouteRef({ id: RoutesIds.pulses });

export const rootRouteRef = pulsesRouteRef;

export const pulseRouteRef = createSubRouteRef({
  id: RoutesIds.pulse,
  parent: rootRouteRef,
  path: '/:id',
});

export const Routes = {
  pulses: pulsesRouteRef,
  pulse: pulseRouteRef,
};
